<template>
  <landing-page label="factSheet.gout" labelColor="#603813" descColor="#603813" :eggImgObj="{ componentName: 'factsheet', imgName: 'goutLandingImage', imgFormat: 'png' }" :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }" />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div>
      <div v-html="t('factSheet.goutDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big space-y-12">
        <template v-for="(item, index) in factSheetStore.goutList" :key="'gout' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.immediateEffects") }}</div>
      <div v-html="t('factSheet.immediateEffectsDesc')" class="space-y-5" />
      <table class="table-auto mt-5 w-full border border-black">
        <thead>
          <tr>
            <th colspan="2">{{ t("factSheet.someImmediateEffects") }}</th>
          </tr>
          <tr>
            <th class="w-1/2 border border-black">{{ t("factSheet.typesOfBloodCholesterol") }}</th>
            <th class="w-1/2 border border-black">{{ t("factSheet.desirableLevels") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in factSheetStore.goutImmediateEffectsList" :key="'goutImmediateEffects' + index">
            <td class="border border-black px-8 py-5">
              {{ t(item.label) }}
            </td>
            <td class="border border-black px-8 py-5">
              <ul class="list-disc bullet-big space-y-5">
                <template v-for="(listItem, idx) in item.list" :key="'goutImmediateEffects' + index + idx">
                  <li>{{ t(listItem) }}</li>
                </template>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-html="t('factSheet.goutRef')" class="mt-5" />

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.gout") }}</div>
      </div>

      <div>
        <div v-html="t('factSheetChinese.goutDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big space-y-12">
          <template v-for="(item, index) in factSheetStore.goutList" :key="'gout' + index"> <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" v-if="item.label != 'factSheet.stayWellHydrated'" /> </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.immediateEffects") }}</div>
        <div v-html="t('factSheetChinese.immediateEffectsDesc')" class="space-y-5" />
        <table class="table-auto mt-5 w-full border border-black">
          <thead>
            <tr>
              <th colspan="2">{{ t("factSheetChinese.someImmediateEffects") }}</th>
            </tr>
            <tr>
              <th class="w-1/2 border border-black">{{ t("factSheetChinese.typesOfBloodCholesterol") }}</th>
              <th class="w-1/2 border border-black">{{ t("factSheetChinese.desirableLevels") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in factSheetStore.goutImmediateEffectsList" :key="'goutImmediateEffects' + index">
              <td class="border border-black px-8 py-5">
                {{ t(item.label.replace("factSheet", "factSheetChinese")) }}
              </td>
              <td class="border border-black px-8 py-5">
                <ul class="list-disc bullet-big space-y-5">
                  <template v-for="(listItem, idx) in item.list" :key="'goutImmediateEffects' + index + idx">
                    <li>{{ t(listItem.replace("factSheet", "factSheetChinese")) }}</li>
                  </template>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-html="t('factSheetChinese.goutRef')" class="mt-5" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>